import { render, staticRenderFns } from "./ProgressCharts.vue?vue&type=template&id=39156f8a&"
import script from "./ProgressCharts.vue?vue&type=script&lang=js&"
export * from "./ProgressCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports